<script>
	import { getContext } from "svelte";

	const { data, custom } = getContext("LayerCake");

	let linkHighlight = $custom.linkHighlight;
	let nodeHighlight = $custom.nodeHighlight;
	let highlightExists = $custom.highlightExists;
	let getLinkId = $custom.getLinkId;

	let handleLinkHover = $custom.handleLinkHover;
	let handleNodeHover = $custom.handleNodeHover;
	let resetHover = $custom.resetHover;
</script>

{#each $data.nodes as d, i}
	{#if d.value}
		{@const highlighted = $nodeHighlight.includes(d.id)}
		{@const type = d.type}
		{@const posLeft = type === "source" ? d.x1 - (d.x1 - d.x0) : type === "target" ? d.x1 : d.x1 - (d.x1 - d.x0) / 2}
		<div
			class="text node {d.type}"
			style:opacity={$highlightExists && !highlighted ? 0.7 : 1}
			style:left="{posLeft}%"
			style:top="{(d.y1 + d.y0) / 2}%"
			on:mouseover={handleNodeHover(d)}
			on:mouseleave={resetHover}
		>
			<slot name="node_label" node={d} {type} {highlighted} />
		</div>
	{/if}
{/each}

{#each $data.links as d, i}
	{@const highlighted = $linkHighlight.includes(getLinkId(d))}
	{@const posLeft = d.source.x1 + (d.target.x0 - d.source.x1) / 2}
	<div class="text link" style:left="{posLeft}%" style:top="{(d.y1 + d.y0) / 2}%">
		<slot name="link_label" link={d} {highlighted} />
	</div>
{/each}

<style lang="scss">
	.text {
		position: absolute;
		// pointer-events: none;
		user-select: none;
		transform: translate(-50%, -50%);
		z-index: 10;

		&.link {
			pointer-events: none;
		}

		&.source {
			transform: translate(-100%, -50%);
			padding-right: 8px;
		}

		&.target {
			transform: translate(0, -50%);
			padding-left: 8px;
		}
	}
</style>
